import { useEffect } from 'react';

import useURLSearchParams from './useUrlSearchParams';

const useAppStyles = (): void => {
	const [{ background, logo, menu, embed }] = useURLSearchParams();

	useEffect(() => {
		const addedClasses: string[] = [];

		if (background === 'false') {
			addedClasses.push('plain-background');
		}

		if (logo === 'false') {
			addedClasses.push('without-logo');
		}

		if (menu === 'false') {
			addedClasses.push('without-sidebar', 'without-menu');
		}

		if (embed === 'true' || embed === '') {
			addedClasses.push('embed-view');
		}

		window.document.body.classList.add(...addedClasses);

		return () => {
			window.document.body.classList.remove(...addedClasses);
		};
	}, [background, logo, menu]);
};

export default useAppStyles;
